import React from 'react';
import PropTypes from 'prop-types';
import AccountPlayersRow from './AccountPlayersRow';
import AccountPlayersHeader from './AccountPlayersHeader';
import TableFooter from '../helpers/TableFooter';
import { isEmpty } from 'lodash';
import { tableNoResultsDefault, tableSpinnerDefault } from '../helpers/TableHelpers';
import { isAdminDashboard } from '../../utils/authScopes';

const AccountPlayersTable = ({ auth, accountPlayers, meta, options, onAccountPlayer, onPageChange, onSortChange, isLoading }) => {
  const rows = accountPlayers.map(row => (
    <AccountPlayersRow key={`${row.id}`} data={row} onAccountPlayer={onAccountPlayer} auth={auth} options={options} withPeriod={!isEmpty(meta.start)} />
  ));
  const columnsCount = isAdminDashboard(auth) ? options.length + 2 : options.length + 1;

  if (isLoading) {
    return (
      <div className='u-margin-bottom--gutter2x'>
        <table className='o-table o-table--ap o-table--bordered'>
          <AccountPlayersHeader meta={meta} onSortChange={onSortChange} auth={auth} options={options} />
          <tbody>
            { tableSpinnerDefault(columnsCount) }
          </tbody>
        </table>
        { meta.totalCount > 0 && <TableFooter meta={meta} onPageChange={onPageChange}/> }
      </div>
    )
  }

  if (!isLoading && isEmpty(accountPlayers)) {
    return (
      <div className='u-margin-bottom--gutter2x'>
        <table className='o-table o-table--ap o-table--bordered'>
          <AccountPlayersHeader meta={meta} onSortChange={onSortChange} auth={auth} options={options} />
          <tbody>
            { tableNoResultsDefault(columnsCount) }
          </tbody>
        </table>
        { meta.totalCount > 0 && <TableFooter meta={meta} onPageChange={onPageChange}/> }
      </div>
    )
  }

  return (
    <div className='u-margin-bottom--gutter2x'>
      <table className='o-table o-table--ap o-table--bordered'>
        <AccountPlayersHeader meta={meta} onSortChange={onSortChange} auth={auth} options={options} />
        <tbody>
          { rows }
        </tbody>
      </table>
      { meta.totalCount > 0 && <TableFooter meta={meta} onPageChange={onPageChange}/> }
    </div>
  );
}

AccountPlayersTable.propTypes = {
  auth: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onAccountPlayer: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  meta: PropTypes.object.isRequired,
  accountPlayers: PropTypes.arrayOf(PropTypes.object).isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default AccountPlayersTable;
